import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import FontKeys from '../FontKeys';
import gameData from '../gameData';

export default class ColorSelectMenu extends Phaser.GameObjects.Container {
  /**
   * 
   * @param {Phaser.Scene} scene 
   */
  constructor(scene) {
    super(scene);

    this.bg = ABCyaPhaser.Images.addImage(0,0,'color-menu-bg', this).setOrigin(0);

    const lblText = ABCyaPhaser.Localization.instance.getLocalizedString('choose_color') ?? 'Choose\nColor';

    this.lbl = ABCyaPhaser.Text.addText(0,0,`${18}pt`, 0x000000, FontKeys._cloudy_with_a_chance_of_lovRg, lblText, this, false).setOrigin(1,0)
      .setAlign('right')
      .setWordWrapWidth(90);
    this.lbl.x = this.lbl.width + 20;
    this.lbl.y = (this.bg.height / 2) - (this.lbl.height / 2);

    /** @type {Phaser.GameObjects.Image[]} */
    this.colorBtns = [];
    while (this.colorBtns.length < 6) {
      const btn = ABCyaPhaser.Images.addImage(0,0,`color-btn-${(this.colorBtns.length + 1).toString()}`, this).setOrigin(0)
        .setInteractive();
      this.colorBtns.push(btn);
      btn.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN,() => this.selectColor(btn));
    }

    this.showSelectedColor(gameData.playerId - 1);
    this.x = (this.scene.scale.width / 2) - (this.bg.width / 2);
    this.y = this.scene.scale.height - this.bg.height;
  }

  selectColor (e) {
    ABCyaPhaser.Audio.playOneShot('button-click', this.scene, 1, false, 0, gameData.gameModeSoundAtlas);
    const btnIndex = this.colorBtns.indexOf(e);
    this.emit('SELECT_COLOR', { _playerId: btnIndex + 1 });
    this.showSelectedColor(btnIndex);
  }

  showSelectedColor (shownIndex) {
    let i = 0;
    while (i < this.colorBtns.length) {
      const btnScale = i === shownIndex ? 1.3 : 1;
      this.colorBtns[i].scale = btnScale;
      i++;
    }

    this.layoutButtons();
  }

  layoutButtons () {
    const btnSpacing = 10;
    const btn = this.colorBtns[0];
    btn.x = this.lbl.x + btnSpacing;
    btn.y = (this.bg.height / 2) - ((btn.width / 2) * btn.scaleY);

    let i = 1;
    while (i < this.colorBtns.length) {
      const btn = this.colorBtns[i];
      btn.x = this.colorBtns[i - 1].x + this.colorBtns[i - 1].width * this.colorBtns[i - 1].scaleX + btnSpacing;
      btn.y = (this.bg.height / 2) - ((btn.width / 2) * btn.scaleY);
      i++;
    }
  }
}